import 'css-chunksrc/client/pages/documentsPage/documentsPage/path/styles.scss';export default {
  "path": "_path_obk0m_1",
  "item": "_item_obk0m_9",
  "planzone": "_planzone_obk0m_22",
  "dropZone": "_dropZone_obk0m_26"
};